import { Injectable, NgZone } from "@angular/core";
import { RoutingService } from "./routing-service";
import { ProvidehttpService } from "./providehttp.service";
import { Data } from "./DataService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { AlertsService } from "./AlertsService";
import { DomSanitizer } from "@angular/platform-browser";
import { ThemeServices } from "./ThemeServices";

@Injectable({
  providedIn: "root",
})
export class ServiceStockParentService {
  public dateDefaltDisplayFormat: string = "dd-mm-yyyy";
  public dateDefaltSaveFormat: string = "dd-mm-yyyy";
  public months=['Jan', 'Feb',  'Mar',  'Apr',  'May', 'Jun', 'Jul',  'Aug', 'Sep',  'Oct', 'Nov', 'Dec' ];
  public gridRowHeight=33;
  public pagination :string='float:left';	
  
  constructor(
    public routing: RoutingService,
    public http: ProvidehttpService,
    public dataStore: Data,
    public modal: NgbModal,
    public translate: TranslateService,
    public theme : ThemeServices,
    public router: Router,
    public alert: AlertsService,
    public ngZone: NgZone,
    public sanitizer: DomSanitizer
  ) {}

  formatAmount(number: number, languageCode: string, minFraction: number) {
    return number.toLocaleString(languageCode, {
      minimumFractionDigits: minFraction,
    });
  }

  formateDate(date:string, inFomate:string, reqFormate:string):string{
    try{
      let dateObj:any= this.parseDate(date,inFomate);
      let format = reqFormate.toUpperCase();
      let saperator;
      let splits;
      let dateString = '';
      if (format.includes('/')) {
        saperator = '/';
        splits = format.split('/');
      } else if (format.includes('-')) {
        saperator = '-';
        splits = format.split('-');
      } else if (format.includes('.')) {
        saperator = '.';
        splits = format.split('.');
      }
      for (var i = 0; i < 3; i++) {
        if (splits[i] == 'YYYY') {
          dateString += dateObj.getFullYear();
        } else if (splits[i] == 'MM') {
          if(dateObj.getMonth() < 10){
            dateString += '0';
          }
          dateString += dateObj.getMonth();
        }else if (splits[i] == "MMM") {
          dateString += this.months[dateObj.getMonth()-1];
        }else {
          if(dateObj.getDate() < 10){
            dateString += '0';
          }
          dateString += dateObj.getDate();
        }
        if (i < 2) {
          dateString += saperator;
        }
      }
      return dateString;
    }catch{
      var consoleErrorMsg ="Invalid Value\n Date Format is: " +inFomate + "\nInput Value is: " +date;
      console.error(consoleErrorMsg);
      return '';
    }
  }

  amountPreOnBlur(value): string {
    return value;
  }

  parseDate(value, format, fieldID = ""):Date {
    let year;
    let month;
    let day;
    let splits;
    let valArray;
    format = format.toUpperCase();
    if (format.includes("/")) {
      splits = format.split("/");
      valArray = value.split("/");
    } else if (format.includes("-")) {
      splits = format.split("-");
      valArray = value.split("-");
    } else if (format.includes(".")) {
      splits = format.split(".");
      valArray = value.split(".");
    } else if (format.includes(",")) {
      splits = format.split(",");
      valArray = value.split(",");
    }

    for (var i = 0; i < 3; i++) {
      if (splits[i] == "YYYY") {
        year = valArray[i];
      } else if (splits[i] == "MM") {
        month = valArray[i];
      } else if (splits[i] == "MMM") {
        month = this.months.indexOf(valArray[i])+1;
      }else {
        day = valArray[i];
      }
    }

    let date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

    if (
      date.getFullYear() == +year &&
      date.getMonth() == +month - 1 &&
      date.getDate() == +day
    ) {
      return date;
    } else {
      var consoleErrorMsg =
        fieldID +
        ".parseDate() : Invalid Value\n Project level Date Format is: " +
        format +
        "\nInput Value is: " +
        value;
      console.error(consoleErrorMsg);
    }

    return undefined;
  }

}
